{
  "id": "worktable1x2",
  "name": "Worktable",
  "builds": "machine",
  "category": "shopFurniture",
  "note": "The standard bench. Most of the shop happens here.",
  "skill": "shopFurniture",
  "duration": 45,
  "offeredBy": "bench",
  "fastener": "nails",
  "widthIn": 48,
  "heightIn": 24,
  "slots": [
    {
      "id": "top-0",
      "role": "top",
      "part": {
        "widthIn": 48,
        "lengthIn": 24,
        "thicknessQ": 3
      },
      "stock": {
        "type": "plywood",
        "sheetGrade": "shopFurniture",
        "thickness": "any"
      },
      "xIn": 24,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "rail-0",
      "role": "rail",
      "part": {
        "widthIn": 4,
        "lengthIn": 48,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [6, 8]
      },
      "xIn": 24,
      "yIn": 4,
      "angleDeg": 90,
      "zIn": 0.75,
      "onEdge": true
    },
    {
      "id": "rail-1",
      "role": "rail",
      "part": {
        "widthIn": 4,
        "lengthIn": 48,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [6, 8]
      },
      "xIn": 24,
      "yIn": 20,
      "angleDeg": 90,
      "zIn": 0.75,
      "onEdge": true
    },
    {
      "id": "stretcher-0",
      "role": "stretcher",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [6, 8]
      },
      "xIn": 16,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 4.75,
      "onEdge": true
    },
    {
      "id": "stretcher-1",
      "role": "stretcher",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [6, 8]
      },
      "xIn": 32,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 4.75,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 8,
      "yIn": 4
    },
    {
      "xIn": 24,
      "yIn": 4
    },
    {
      "xIn": 40,
      "yIn": 4
    },
    {
      "xIn": 8,
      "yIn": 20
    },
    {
      "xIn": 24,
      "yIn": 20
    },
    {
      "xIn": 40,
      "yIn": 20
    },
    {
      "xIn": 16,
      "yIn": 4
    },
    {
      "xIn": 32,
      "yIn": 4
    },
    {
      "xIn": 16,
      "yIn": 20
    },
    {
      "xIn": 32,
      "yIn": 20
    }
  ]
}
